import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import { createContext, type PropsWithChildren } from 'react';
import { useRadioGroup } from 'react-aria';
import type { RadioGroupProps, RadioGroupState } from 'react-stately';
import { useRadioGroupState } from 'react-stately';

interface ChooseButtonGroupProps extends PropsWithChildren {
  readonly amount?: number;
  readonly hasMaxRingCount?: boolean;
  readonly hideLabel?: boolean;
  readonly aboveButtonGroupSlot?: JSX.Element;
}

export const RadioContext = createContext<RadioGroupState | null>(null);

const ChooseButtonGroup = (
  props: RadioGroupProps & ChooseButtonGroupProps,
): JSX.Element | null => {
  const {
    amount,
    children,
    hasMaxRingCount,
    hideLabel = false,
    label,
    description,
    aboveButtonGroupSlot,
  } = props;
  const state = useRadioGroupState(props);
  const t = useTranslations();

  const { radioGroupProps, labelProps, descriptionProps } = useRadioGroup(
    props,
    state,
  );

  return (
    <>
      <TypographyV3
        className={cx('mb-2 lg:mb-1 lg:text-xl', {
          'mb-4 lg:mb-4': !description,
        })}
        data-cy="style-title"
        aria-label={t(label)}
      >
        <span {...labelProps}>{!hideLabel ? t(label) : ''}</span>
      </TypographyV3>
      {description && (
        <TypographyV3 className="mb-4">
          <span {...descriptionProps}>
            {t(description, hasMaxRingCount ? { amount } : {})}
          </span>
        </TypographyV3>
      )}
      {Boolean(aboveButtonGroupSlot) && aboveButtonGroupSlot}
      <div {...radioGroupProps}>
        <div className="relative flex w-full flex-col gap-2.5">
          <RadioContext.Provider value={state}>
            {children}
          </RadioContext.Provider>
        </div>
      </div>
    </>
  );
};

export default ChooseButtonGroup;
